// Unit Types API
export const unitTypesApi = {
    async getUnitTypes(api, integrationId, category) {
        const params = new URLSearchParams();
        if (category)
            params.append('category', category);
        const response = await api.get(`/api/v1/integrations/${integrationId}/unit-types?${params}`);
        return response.data.data || [];
    },
    async createUnitType(api, integrationId, data) {
        const response = await api.post(`/api/v1/integrations/${integrationId}/unit-types`, data);
        return response.data.data;
    },
    async updateUnitType(api, integrationId, unitTypeId, data) {
        const response = await api.put(`/api/v1/integrations/${integrationId}/unit-types/${unitTypeId}`, data);
        return response.data.data;
    },
    async deleteUnitType(api, integrationId, unitTypeId) {
        await api.delete(`/api/v1/integrations/${integrationId}/unit-types/${unitTypeId}`);
    },
};
// Container Types API
export const containerTypesApi = {
    async getContainerTypes(api, integrationId) {
        const response = await api.get(`/api/v1/integrations/${integrationId}/container-types`);
        return response.data.data || [];
    },
    async createContainerType(api, integrationId, data) {
        const response = await api.post(`/api/v1/integrations/${integrationId}/container-types`, data);
        return response.data.data;
    },
    async updateContainerType(api, integrationId, woveCode, data) {
        const response = await api.put(`/api/v1/integrations/${integrationId}/container-types/${woveCode}`, data);
        return response.data.data;
    },
    async deleteContainerType(api, integrationId, woveCode) {
        await api.delete(`/api/v1/integrations/${integrationId}/container-types/${woveCode}`);
    },
};
// CargoWise Organizations API
export const cargowiseOrganizationsApi = {
    async getOrganizations(api, activeOnly) {
        const params = activeOnly !== undefined ? `active=${activeOnly}` : '';
        const response = await api.get(`/api/v1/cargowise/organizations?${params}`);
        return response.data.data || [];
    },
    async getOrganization(api, organizationId) {
        const response = await api.get(`/api/v1/cargowise/organizations/${organizationId}`);
        return response.data.data;
    },
    async createOrganization(api, data) {
        const response = await api.post(`/api/v1/cargowise/organizations`, data);
        return response.data.data;
    },
    async updateOrganization(api, organizationId, data) {
        const response = await api.put(`/api/v1/cargowise/organizations/${organizationId}`, data);
        return response.data.data;
    },
    async deleteOrganization(api, organizationId) {
        await api.delete(`/api/v1/cargowise/organizations/${organizationId}`);
    },
    async searchOrganizations(api, query) {
        const response = await api.get(`/api/v1/cargowise/organizations/search?q=${encodeURIComponent(query)}`);
        return response.data.data || [];
    },
};
// CargoWise Handling Methods API
export const cargowiseHandlingMethodsApi = {
    async getHandlingMethods(api, activeOnly) {
        const params = activeOnly !== undefined ? `active=${activeOnly}` : '';
        const response = await api.get(`/api/v1/cargowise/handling-methods?${params}`);
        return response.data.data || [];
    },
    async getHandlingMethod(api, handlingMethodId) {
        const response = await api.get(`/api/v1/cargowise/handling-methods/${handlingMethodId}`);
        return response.data.data;
    },
    async createHandlingMethod(api, data) {
        const response = await api.post(`/api/v1/cargowise/handling-methods`, data);
        return response.data.data;
    },
    async updateHandlingMethod(api, handlingMethodId, data) {
        const response = await api.put(`/api/v1/cargowise/handling-methods/${handlingMethodId}`, data);
        return response.data.data;
    },
    async deleteHandlingMethod(api, handlingMethodId) {
        await api.delete(`/api/v1/cargowise/handling-methods/${handlingMethodId}`);
    },
    async searchHandlingMethods(api, query) {
        const response = await api.get(`/api/v1/cargowise/handling-methods/search?q=${encodeURIComponent(query)}`);
        return response.data.data || [];
    },
};
// Custom Field Mappings API
export const customFieldMappingsApi = {
    async getCustomFieldMappings(api, integrationId) {
        const response = await api.get(`/api/v1/integrations/${integrationId}/integration-custom-fields`);
        return response.data.data || [];
    },
    async createCustomFieldMapping(api, integrationId, data) {
        const response = await api.post(`/api/v1/integrations/${integrationId}/integration-custom-fields`, data);
        return response.data.data;
    },
    async updateCustomFieldMapping(api, integrationId, fieldId, data) {
        const response = await api.put(`/api/v1/integrations/${integrationId}/integration-custom-fields/${fieldId}`, data);
        return response.data.data;
    },
    async deleteCustomFieldMapping(api, integrationId, fieldId) {
        await api.delete(`/api/v1/integrations/${integrationId}/integration-custom-fields/${fieldId}`);
    },
};
// Integration Settings API
export const integrationSettingsApi = {
    async getIntegrationSettings(api, integrationId) {
        const response = await api.get(`/api/v1/integrations/${integrationId}/settings`);
        return response.data || {};
    },
    async updateIntegrationSettings(api, integrationId, data) {
        const response = await api.put(`/api/v1/integrations/${integrationId}/settings`, data);
        return response.data;
    },
    async getCargoWiseSettings(api, integrationId) {
        const response = await api.get(`/api/v1/integrations/${integrationId}/settings/cargowise`);
        return response.data || null;
    },
    async updateCargoWiseSettings(api, integrationId, data) {
        const response = await api.put(`/api/v1/integrations/${integrationId}/settings/cargowise`, data);
        return response.data;
    },
    async testIntegrationConnection(api, integrationId, testData) {
        const response = await api.post(`/api/v1/integrations/${integrationId}/settings/test`, testData);
        return response.data;
    },
    async testCargoWiseConnection(api, integrationId, credentials) {
        const response = await api.post(`/api/v1/integrations/${integrationId}/settings/cargowise/test`, credentials);
        return response.data;
    },
};
// Integrations API
export const integrationsApi = {
    async getIntegrations(api) {
        const response = await api.get('/api/v1/integrations');
        return response.data.data || [];
    },
    async createIntegration(api, data) {
        const response = await api.post('/api/v1/integrations', data);
        return response.data.data;
    },
    async getIntegration(api, integrationId) {
        const response = await api.get(`/api/v1/integrations/${integrationId}`);
        return response.data.data;
    },
    async updateIntegration(api, integrationId, data) {
        const response = await api.put(`/api/v1/integrations/${integrationId}`, data);
        return response.data.data;
    },
    async deleteIntegration(api, integrationId) {
        await api.delete(`/api/v1/integrations/${integrationId}`);
    },
};
